import type { RoutingAddress } from 'types/entities/einvoicing/routingAddress.type';

// TODO(SAAS-32515): drop this mock override once the backend exposes the routing-addresses API.
// - 'auto'          → populated state with mocked routing addresses (default working state)
// - 'loading'       → keep the loading skeleton visible (promise never resolves)
// - 'siren-missing' → force the "SIREN required" empty state
// - 'not-detected'  → force the "not detected on the directory" empty state
export type MockDisplayOverride = 'auto' | 'loading' | 'siren-missing' | 'not-detected';
export const MOCK_DISPLAY_OVERRIDE = 'auto' as MockDisplayOverride;

const MOCK_ADDRESSES: RoutingAddress[] = [
    { id: 1, code: '123456789', name: null, isDefault: true, format: 'peppol' },
    {
        id: 2,
        code: '123456789_jean_service_compta_jeanMichelComptable',
        name: 'Jean Michel Comptable',
        isDefault: false,
        format: 'peppol',
    },
];

export const fetchRoutingAddresses = async (): Promise<RoutingAddress[]> => {
    // TODO(SAAS-32515): replace with real ApiClient.get call when backend is ready.
    // While mocked, only 'auto' returns populated data; the other overrides render an empty state
    // before the list would be consumed, so the value here doesn't matter for them.
    if (MOCK_DISPLAY_OVERRIDE === 'loading') {
        return new Promise<RoutingAddress[]>(() => {});
    }
    return MOCK_DISPLAY_OVERRIDE === 'auto' ? MOCK_ADDRESSES : [];
};
